module.exports = __webpack_public_path__ + "img/CovidSector_Infographics_12.158a43f1.png";